import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { post, del } from '../lib/api';
import TopBar from '../components/layout/TopBar';
import SectionCard from '../components/widgets/SectionCard';
import { Plus, Trash2, FolderKanban } from 'lucide-react';
import { toast } from 'sonner';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../components/ui/dialog';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../components/ui/select';

export default function Projetos() {
  const { companies, projects, reloadProjects } = useApp();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ company_id: '', name: '', code: '', description: '' });

  const submit = async () => {
    if (!form.company_id || !form.name.trim()) return toast.error('Empresa e nome obrigatórios');
    await post('/projects', { ...form, code: form.code || null, description: form.description || null });
    toast.success('Projeto criado');
    setOpen(false);
    setForm({ company_id: '', name: '', code: '', description: '' });
    reloadProjects();
  };

  const remove = async (id) => {
    if (!window.confirm('Excluir?')) return;
    await del(`/projects/${id}`);
    reloadProjects();
  };

  return (
    <div className="fade-in">
      <TopBar
        title="Fontes de Receita"
        subtitle={`${projects.length} fontes de receita cadastradas`}
        action={
          <Button onClick={() => setOpen(true)} className="btn-gold rounded-md gap-1.5 px-4" data-testid="btn-new-project">
            <Plus size={15} /> Nova Fonte
          </Button>
        }
      />
      <div className="px-8 py-7">
        <SectionCard padded={false}>
          <div className="overflow-x-auto">
            <table className="w-full ceap-table">
              <thead>
                <tr>
                  <th>Fonte de Receita</th>
                  <th>Empresa</th>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th className="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((p) => {
                  const co = companies.find((c) => c.id === p.company_id);
                  return (
                    <tr key={p.id} data-testid={`project-row-${p.id}`}>
                      <td>
                        <div className="flex items-center gap-2">
                          <FolderKanban size={13} className="text-zinc-500" />
                          <span className="text-zinc-100">{p.name}</span>
                        </div>
                      </td>
                      <td className="text-zinc-300 text-xs">{co?.name || '-'}</td>
                      <td className="font-mono text-zinc-400 text-xs">{p.code || '—'}</td>
                      <td className="text-zinc-400 text-xs">{p.description || '—'}</td>
                      <td className="text-right">
                        <button onClick={() => remove(p.id)} className="p-1.5 rounded hover:bg-red-900/30 text-zinc-400 hover:text-red-400" data-testid={`btn-delete-project-${p.id}`}>
                          <Trash2 size={13} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </SectionCard>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
          <DialogHeader><DialogTitle className="font-display">Novo Projeto</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Empresa *</Label>
              <Select value={form.company_id} onValueChange={(v) => setForm({ ...form, company_id: v })}>
                <SelectTrigger className="bg-zinc-900 border-zinc-800 mt-1"><SelectValue placeholder="Empresa" /></SelectTrigger>
                <SelectContent className="bg-zinc-900 border-zinc-800 text-zinc-100">
                  {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Nome *</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-zinc-900 border-zinc-800 mt-1" data-testid="input-project-name" />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Código</Label>
              <Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} className="bg-zinc-900 border-zinc-800 mt-1 font-mono" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} className="text-zinc-400 hover:bg-zinc-900">Cancelar</Button>
            <Button onClick={submit} className="btn-gold" data-testid="btn-save-project">Criar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
